import { useCallback, useState } from "react";
import { Outlet } from "react-router-dom";

import Header from "components/header/header-main"
import Footer from "components/header/footer"

import styled from "styled-components";
import Modal from "components/modal";

import 'assets/css/top.scss';

const DialogButton = styled.button`
  width: 160px;
  height: 48px;
  background-color: blueviolet;
  color: white;
  font-size: 1.2rem;
  font-weight: 400;
  border-radius: 4px;
  border: none;
  cursor: pointer;

  &:hover {
    transform: translateY(-1px);
  }
`;

export default function DefaultLayout() {
  const [isOpenModal, setOpenModal] = useState<boolean>(false);

  const onClickToggleModal = useCallback(() => {
    setOpenModal(!isOpenModal);
  }, [isOpenModal]);

  return (
    <>
      <div>
        <Header />
        <div>
          <Outlet />
        </div>
        <div className="footer-section">
          <Footer/>
        </div>
      </div>
      <div id="dimmed"></div>
      {isOpenModal && (
        <Modal onClickToggleModal={onClickToggleModal}>
          <DialogButton onClick={onClickToggleModal}>close</DialogButton>
          내용
        </Modal>
      )}
    </>
  );
}
